import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pencel",
  "use": "pencel-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"pencel\">\n<title>pencel</title>\n<path d=\"M4.367 21.834l16.716-16.751 5.834 5.834-16.751 16.716-5.8-5.8zM26.2 0l5.8 5.8-3.616 3.65-5.834-5.834 3.65-3.616zM2.9 23.267l5.834 5.834-8.733 2.9 2.9-8.733z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol